import { render, staticRenderFns } from "./CanvasPageIntegrityDialog.vue?vue&type=template&id=38ca471e&scoped=true&"
import script from "./CanvasPageIntegrityDialog.vue?vue&type=script&lang=js&"
export * from "./CanvasPageIntegrityDialog.vue?vue&type=script&lang=js&"
import style0 from "./CanvasPageIntegrityDialog.vue?vue&type=style&index=0&id=38ca471e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ca471e",
  null
  
)

export default component.exports